import { call, setToken } from './client'
import { tg } from '../lib/telegram'
import type { Session, User } from '../types'

export async function login(): Promise<User> {
  const initData = tg?.initData
  if (!initData) throw new Error('Открой приложение из Telegram: вне его нет подписи входа')
  const session = await call<Session>('/auth/telegram', {
    method: 'POST',
    body: { init_data: initData },
  })
  setToken(session.token)
  return session.user
}
